import WebFont from 'webfontloader';

export default {
  init() {
    // JavaScript to be fired on all pages
    function onResize(c, t) { onresize = function () { clearTimeout(t); t = setTimeout(c, 500); }; return c; }

    WebFont.load({
      google: {
        families: ['Cutive', 'Montserrat:400,400i,500, 500i, 700,700i'],
      },
    });

    $('.btn-menu').on('click', function () {
      var $button = $(this);
      var $nav = $('.nav-primary');

      $button.toggleClass('btn-menu--active');
      $nav.toggleClass('nav-primary--active');
      $('body').toggleClass('nav-visible');
    });

    $('.back-to-top').on('click', function(e) {
      e.preventDefault;

      $('html, body').animate({ scrollTop: 0 });
    });

    // Use Bootstrap Collapse on sub menus
    var togglKollaps = function () {
      var $button = $(this);
      var $parent = $(this).parent('.menu-item-has-children');
      var $sub_menu = $parent.find('> .sub-menu');

      $button.toggleClass('sub-menu-visible');
      $sub_menu.collapse('toggle');
    }

    // When should the sub menus collapse vs their default state
    function kollaps() {
      var $sub_menu = $('.nav-mobile .nav > .menu-item-has-children > .sub-menu');
      var $button = $('.nav-mobile .nav > .menu-item-has-children > .collapse-icon');

      if ($(window).width() < 992) {
        $sub_menu.addClass('collapse');
        $button.on('click', togglKollaps);
      } else {
        $sub_menu.removeClass('collapse');
        $button.off('click', togglKollaps);
      }
    }

    onResize(function () {
      kollaps();
    })();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js